import React from 'react'

interface UploadIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const UploadIcon: React.FC<UploadIconProps> = ({
  color = '#000',
  gradient,
  width = 18,
  height = 17,
  alt = 'Upload icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 17'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.068.183a.625.625 0 0 0-.884 0L4.207 4.161a.625.625 0 0 0 .883.883L8 2.134v10.491a.625.625 0 1 0 1.25 0V2.134l2.911 2.91a.625.625 0 0 0 .884-.883zM1.25 12.625a.625.625 0 1 0-1.25 0v3c0 .345.28.625.625.625h16c.345 0 .625-.28.625-.625v-3a.625.625 0 1 0-1.25 0V15H1.25z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default UploadIcon
